export const BANK_COMMODITIES_GETALL = "BANK_COMMODITIES_GETALL";
export const BANK_COMMODITIES_GETALL_PENDING =
  "BANK_COMMODITIES_GETALL_PENDING";
export const BANK_COMMODITIES_GETALL_SUCCESS =
  "BANK_COMMODITIES_GETALL_SUCCESS";
export const BANK_COMMODITIES_GETALL_ERROR = "BANK_COMMODITIES_GETALL_ERROR";

export const BANK_COMMODITY_SAVE = "BANK_COMMODITY_SAVE";

export const BANK_COMMODITY_SAVE_PENDING = "BANK_COMMODITY_SAVE_PENDING";

export const BANK_COMMODITY_SAVE_SUCCESS = "BANK_COMMODITY_SAVE_SUCCESS";

export const BANK_COMMODITY_SAVE_ERROR = "BANK_COMMODITY_SAVE_ERROR";

export const BANKCOMMODITIES_GET_COMMODITY = "BANKCOMMODITIES_GET_COMMODITY";

export const BANKCOMMODITIES_GET_COMMODITY_PENDING =
  "BANKCOMMODITIES_GET_COMMODITY_PENDING";

export const BANKCOMMODITIES_GET_COMMODITY_SUCCESS =
  "BANKCOMMODITIES_GET_COMMODITY_SUCCESS";

export const BANKCOMMODITIES_GET_COMMODITY_ERROR =
  "BANKCOMMODITIES_GET_COMMODITY_ERROR";

// export const BANKCOMMODITIES_GET_SUPPLIER = "BANKCOMMODITIES_GET_SUPPLIER";

// export const BANKCOMMODITIES_GET_SUPPLIER_PENDING =
//   "BANKCOMMODITIES_GET_SUPPLIER_PENDING";

// export const BANKCOMMODITIES_GET_SUPPLIER_SUCCESS =
//   "BANKCOMMODITIES_GET_SUPPLIER_SUCCESS";

// export const BANKCOMMODITIES_GET_SUPPLIER_ERROR =
//   "BANKCOMMODITIES_GET_SUPPLIER_ERROR";

export const BANKCOMMODITIES_GET_PURCHASER = "BANKCOMMODITIES_GET_PURCHASER";

export const BANKCOMMODITIES_GET_PURCHASER_PENDING =
  "BANKCOMMODITIES_GET_PURCHASER_PENDING";

export const BANKCOMMODITIES_GET_PURCHASER_SUCCESS =
  "BANKCOMMODITIES_GET_PURCHASER_SUCCESS";

export const BANKCOMMODITIES_GET_PURCHASER_ERROR =
  "BANKCOMMODITIES_GET_PURCHASER_ERROR";

export const BANKCOMMODITIES_GET = "BANKCOMMODITIES_GET";

export const BANKCOMMODITIES_GET_PENDING = "BANKCOMMODITIES_GET_PENDING";

export const BANKCOMMODITIES_GET_ERROR = "BANKCOMMODITIES_GET_ERROR";

export const BANKCOMMODITIES_GET_SUCCESS = "BANKCOMMODITIES_GET_SUCCESS";

export const DUPLICATE_REFENCE_ERROR = "DUPLICATE_REFENCE_ERROR";

export const DELETE_BANK_COMMODITY = "DELETE_BANK_COMMODITY";

export const DELETE_BANK_COMMODITY_PENDING = "DELETE_BANK_COMMODITY_PENDING";

export const DELETE_BANK_COMMODITY_SUCCESS = "DELETE_BANK_COMMODITY_SUCCESS";

export const DELETE_BANK_COMMODITY_ERROR = "DELETE_BANK_COMMODITY_ERROR";
